module.exports = __webpack_public_path__ + "static/media/ios-snow.e00dc9ab.svg";